import React from "react";
import { CircleDollarSign, FileSearch, TrendingUp, ChartPie, GitMerge, Lightbulb } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Aircraft Sourcing",
  description: "Identifying and securing off-market opportunities through our global network of owners and elite operators.",
  icon: FileSearch,
  href: "#"
}, {
  title: "Jet Management",
  description: "Comprehensive Part 91 oversight focused on operational efficiency, safety, and asset preservation for family offices.",
  icon: TrendingUp,
  href: "#"
}, {
  title: "Sales & Acquisitions",
  description: "Strategic advisory for complex transactions, leveraging deep market intelligence to maximize your asset's value.",
  icon: CircleDollarSign,
  href: "#"
}, {
  title: "Aviation Consulting",
  description: "Expert guidance on fleet optimization, operational audits, and regulatory compliance for Part 91/135 operations.",
  icon: Lightbulb,
  href: "/AdvisoryPage"
}, {
  title: "Private Charter Advisor",
  description: "On-demand access to a curated fleet of premium aircraft, ensuring seamless global travel without ownership burdens.",
  icon: GitMerge,
  href: "#"
}, {
  title: "Trip Support",
  description: "White-glove logistics management including crew coordination, ground handling, and bespoke in-flight services.",
  icon: ChartPie,
  href: "#"
}];
export default function CoreIntelligenceSuites() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="57947" id="our-core-capabilities" className="dark bg-[#050505] text-foreground py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff03_1px,transparent_1px),linear-gradient(to_bottom,#ffffff03_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)] pointer-events-none" />

      <div className="max-w-7xl mx-auto relative z-10" ref={ref}>
        <div className={`text-center mb-16 transition-all duration-700 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-white mb-4 font-sans">
            Our Core Capabilities
          </h2>
          <p className="text-[#A1A1A1] max-w-2xl mx-auto text-lg font-sans">
            Precision-engineered aviation solutions tailored for UHNW individuals, family offices, and corporate flight departments.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, i) => <div key={i} className="block h-full group outline-none" data-index={i}>
              <Card className={`
                  h-full border border-[#2A2A2A] bg-[#0A0A0A] 
                  transition-all duration-500 ease-out
                  hover:border-[#FF5F1F] hover:bg-[radial-gradient(circle_at_center,rgba(255,95,31,0.05)_0%,transparent_100%)]
                  hover:shadow-[0_0_30px_-10px_rgba(255,95,31,0.2)]
                  transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}
                `} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <CardHeader className="relative pb-2">
                  <div className="mb-6 inline-flex items-center justify-center w-12 h-12 rounded-none bg-white/5 border border-white/10 group-hover:border-[#FF5F1F]/50 group-hover:bg-[#FF5F1F]/10 transition-colors duration-300">
                    <service.icon className="w-6 h-6 text-[#FF5F1F] stroke-[1.5px] transition-transform duration-300 group-hover:scale-110" />
                  </div>
                  <CardTitle className="text-xl font-bold text-white group-hover:text-white transition-colors font-sans tracking-tight">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="relative">
                  <CardDescription className="text-sm leading-relaxed text-[#A1A1A1] group-hover:text-gray-300 transition-colors mb-6 font-sans">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}